import { toString1pkumu07cwy4m as toString } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function accept(_this__u8e3s4, contentType) {
  return _this__u8e3s4.get_headers_ef25jx_k$().append_rhug0a_k$('Accept', contentType.toString());
}
function header(_this__u8e3s4, key, value) {
  var tmp;
  if (value == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.let' call
    _this__u8e3s4.get_headers_ef25jx_k$().append_rhug0a_k$(key, toString(value));
    tmp = Unit_instance;
  }
  var tmp1_elvis_lhs = tmp;
  return tmp1_elvis_lhs == null ? Unit_instance : tmp1_elvis_lhs;
}
//region block: exports
export {
  accept as accept2gi3b7wj4jds9,
  header as header3kx6g3yb4df1r,
};
//endregion

//# sourceMappingURL=utils.mjs.map
